import { useMemo } from 'react';

export const useRows = (data) =>
  useMemo(
    () =>
      data.map((item) => {
        const [
          name,
          vacation,
          holiday,
          earnedTime,
          personal,
          training,
          bereavement,
          unionBusiness,
          departmentBusiness,
          selfSick,
          familySick,
          leaveWithPay,
          leaveWithoutPay,
          swap,
          injured,
          academy,
          openPosition,
          ffcra,
        ] = item;

        return {
          name,
          vacation,
          holiday,
          earnedTime,
          personal,
          training,
          bereavement,
          unionBusiness,
          departmentBusiness,
          selfSick,
          familySick,
          leaveWithPay,
          leaveWithoutPay,
          swap,
          injured,
          academy,
          openPosition,
          ffcra,
        };
      }),
    [data]
  );
